var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { Grid } from '@mui/material';
import { FormikTextField } from '../../atoms/TextField';
import { FormikSelectField } from '../../atoms/SelectField';
import PageSubmitButton from '../../molecules/PageSubmitButton';
import { roasterAddress as api } from '../../../api';
import { useNotify } from '../../../hooks/notificationHook';
import { useRequest } from '../../../hooks/requestHook';
import { camelize } from '../../../utils/camelize';
import FormikSelectCountryCallingCodeField from '../../atoms/FormikSelectCountryCallingCodeField';
import { JP_PREFECTURES } from '../../../constants/roasterValues';
import { AddressFormats, JapanAddressFormats, JapanRoasterAddressHalfWidthMaxLength, JapanRoasterBuildingHalfWidthMaxLength, japanRoasterAddressTest, japanRoasterBuildingTest, } from '../../../constants/fieldFormats';
var toFormikValue = function (roaster, address) {
    return {
        billing_name: address.billingName,
        store_name: address.storeName,
        person_name: address.personName,
        name_kana: address.nameKana,
        postal_code: address.postalCode,
        prefecture: address.prefecture,
        city: address.city,
        address: address.address,
        building: address.building,
        phone: address.phone,
        country_calling_code: address.countryCallingCode || roaster.countryCallingCode,
        email: address.email,
    };
};
var REQUIRED_FIELDS = [
    'person_name',
    'postal_code',
    'prefecture',
    'city',
    'address',
    'phone',
    'country_calling_code',
    'email',
];
var AddressForm = function (_a) {
    var roaster = _a.roaster, address = _a.address, onSuccess = _a.onSuccess;
    var t = useTranslation().t;
    var notify = useNotify();
    var createAddress = useRequest(api.create);
    var updateAddress = useRequest(api.update);
    var isExistsRecord = Boolean(address.id);
    var create = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createAddress({
                        roasterId: roaster.id,
                        address: __assign({ address_type: address.addressType }, values),
                    })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.createSuccess')]);
                    onSuccess();
                    return [2 /*return*/];
            }
        });
    }); }, [roaster.id, notify, t, createAddress, address, onSuccess]);
    var update = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateAddress({
                        roasterId: roaster.id,
                        id: address.id,
                        address: __assign({}, values),
                    })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.updateSuccess')]);
                    onSuccess();
                    return [2 /*return*/];
            }
        });
    }); }, [roaster.id, notify, t, updateAddress, address, onSuccess]);
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = isExistsRecord ? update : create;
                    return [4 /*yield*/, request(values)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [isExistsRecord, create, update]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        var requiredFields = address.addressType === 'billing'
            ? __spreadArray(['billing_name'], REQUIRED_FIELDS, true) : __spreadArray([], REQUIRED_FIELDS, true);
        requiredFields.forEach(function (field) {
            if (!values[field] || values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.address.".concat(camelize(field))),
                });
            }
        });
        Object.entries(roaster.country.code === 'JP' ? JapanAddressFormats : AddressFormats).forEach(function (_a) {
            var field = _a[0], regExp = _a[1];
            var fieldAsKey = field;
            var value = values[fieldAsKey];
            if (value && !regExp.test(value)) {
                var invalidKey = 'invalid';
                if (roaster.country.code === 'JP') {
                    if (field === 'postal_code')
                        invalidKey = 'invalidPostalCode';
                    if (field === 'city')
                        invalidKey = 'invalidCity';
                }
                errors[fieldAsKey] = t("errors.".concat(invalidKey), {
                    field: t("params.order.".concat(camelize(field))),
                });
            }
        });
        if (roaster.country.code === 'JP') {
            if (values.address && !japanRoasterAddressTest(values.address)) {
                errors.address = t('errors.invalidAddress', {
                    field: t('params.roaster.address'),
                    fullWidthMaxLength: JapanRoasterAddressHalfWidthMaxLength / 2,
                    halfWidthMaxLength: JapanRoasterAddressHalfWidthMaxLength,
                });
            }
            if (values.building && !japanRoasterBuildingTest(values.building)) {
                errors.building = t('errors.invalidAddress', {
                    field: t('params.roaster.building'),
                    fullWidthMaxLength: JapanRoasterBuildingHalfWidthMaxLength / 2,
                    halfWidthMaxLength: JapanRoasterBuildingHalfWidthMaxLength,
                });
            }
        }
        return errors;
    }, [t, address.addressType]);
    var formik = useFormik({
        initialValues: toFormikValue(roaster, address),
        onSubmit: onSubmit,
        validate: validate,
        validateOnChange: true,
        validateOnMount: true,
        enableReinitialize: true,
    });
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement(Grid, { container: true, spacing: 2 },
            address.addressType === 'billing' && (React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "billing_name", label: t('params.address.billingName'), required: true, formik: formik }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "store_name", label: t('params.address.storeName'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "person_name", label: t('params.address.personName'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "name_kana", label: t("params.address.nameKana"), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "postal_code", inputProps: { maxLength: roaster.country.code === 'JP' ? 7 : 9 }, label: t('params.address.postalCode'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 }, roaster.country.code === 'JP' ? (React.createElement(FormikSelectField, { label: t('params.roaster.prefecture'), name: "prefecture", items: JP_PREFECTURES.map(function (prefecture) {
                    return { text: prefecture, value: prefecture };
                }), fullWidth: true, required: true, formik: formik })) : (React.createElement(FormikTextField, { fullWidth: true, name: "prefecture", label: t("params.address.prefecture"), required: true, formik: formik }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "city", label: t("params.address.city"), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "address", label: t("params.address.address"), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "building", label: t('params.address.building'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 2 },
                React.createElement(FormikSelectCountryCallingCodeField, { name: "country_calling_code", required: true, label: t('params.address.countryCallingCode'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                React.createElement(FormikTextField, { fullWidth: true, name: "phone", label: t('params.address.phone'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "email", label: t('params.address.email'), required: true, formik: formik }))),
        React.createElement(PageSubmitButton, { disabled: !formik.isValid }, isExistsRecord ? t('buttons.update') : t('buttons.create'))));
};
export default AddressForm;
